import React, { useEffect, useState } from 'react';
import { inject } from 'mobx-react';
import { useClassName } from 'common/hooks';

import './upcoming-bookings.less';

const UpcomingBookings = ({ handleLinkClick, me }) => {
  const className = useClassName('UpcomingBookings');
  const [upcomingOrdersCount, setUpcomingOrdersCount] = useState(
    me.upcomingOrdersCount
  );

  useEffect(() => {
    const getUpcomingOrdersCount = async () => {
      if (me?.upcomingOrdersCount === undefined) {
        const count = await me.fetchUpcomingOrdersCount();
        setUpcomingOrdersCount(count);
      }
    };
    getUpcomingOrdersCount();
  }, []);

  const handleBookingsClick = () =>
    handleLinkClick('/profile', 'Nav My bookings clicked');

  if (!upcomingOrdersCount) return null;

  return (
    <div className={className('container')}>
      <div className={className('content')} onClick={handleBookingsClick}>
        <div className={className('title')}>MY BOOKINGS</div>
        <div className={className('count')}>{upcomingOrdersCount}</div>
      </div>
    </div>
  );
};

export default inject('me')(UpcomingBookings);
